/// <amd-module name="Wit/WitOpenDialogContent/WitOpenDialogService" />
import { Services, VssService } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";
import { IWorkItemTrackingRestClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking.Types";
import { IWorkItemService } from "Wit/WorkItem/Service/Contracts";

class WitOpenDialogService extends VssService {
    public openDialog(): void {
        const historyService = this.pageContext.getService<IVssHistoryService>("IVssHistoryService");
        const state = historyService.getState();
        if (state.workitem) {
            // show work item
            const workItemId = this.parseWorkItemId(state.workitem);

            if (workItemId > 0) {
                const client = this.pageContext.getRestClient<IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
                const service = this.pageContext.getService<IWorkItemService>("work-item-service");
                client.getWorkItem(workItemId, undefined, ["System.Id"]).then(
                    workItem => {
                        // We want to delete the work item query param before we open the work item , because once we open the work item, we add
                        // a new state and since work item dialog uses the old navigation history service, we end up with two different states.
                        // To avoid this, we delete the workitem query param.
                        this.deleteWorkItemQueryParam(historyService, state);
                        if (service && workItem) {
                            service.openWorkItem(workItemId, { addQueryParam: true });
                        }
                    },
                        (error: Error) => {
                            // If we error out in getting the work item remove the query param
                            this.deleteWorkItemQueryParam(historyService, state);
                        }
                );
            }
            else {
                // If the Work item is invalid we want to remove the query param
                this.deleteWorkItemQueryParam(historyService, state);
            }
        }
    }

    public parseWorkItemId(str: string): number {
        const numericValue = parseInt(str, 10);
        if (!isNaN(numericValue) && numericValue.toString() === str) {
            return numericValue;
        } else {
            return -1;
        }
    }

    private deleteWorkItemQueryParam(historyService: IVssHistoryService, state: any) {
        delete state["workitem"];
        historyService.replaceState(state);
    }
}

Services.add("WitOpenDialogService", { serviceFactory: WitOpenDialogService });
